import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ProductConfigurationService } from '@fleet/product-configuration';

import { OnscreenNotificationService } from '@fleet/ui/onscreen-notification/onscreen-notification.service';
import { failureNotification } from '@fleet/utilities';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  fleetProduct: string;
  constructor(
    private _authService: AuthService,
    @Inject('env') env: any,
    private router: Router,
    private onScreenNotitifcationService: OnscreenNotificationService,
    private productConfigurationService: ProductConfigurationService
  ) {
    this.fleetProduct = env.fleetProduct;
  }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.method === 'JSONP') {
      return next.handle(req);
    }

    // Clone the request object
    let newReq = req.clone();

    const jwt = localStorage.getItem('access_token');

    // A valid JWT always takes priority over any other auth mechanism, because a JWT
    // means the user is a real authenticated person (including authenticated travellers).
    if (jwt && !this._authService.isTokenExpired()) {
      newReq = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this._authService.accessToken,
          'fleet-product': this.fleetProduct,
          'fleet-channel': 'WEB',
        },
      });
    } else if (
      this.fleetProduct === 'TRAVELLER' &&
      this.productConfigurationService.configValue?.apiKeys?.['TRAVELLER']
    ) {
      // x-api-key is used exclusively for guest (unauthenticated) travellers and is
      // deliberately overridden when a JWT is present.
      const xApiKey =
        this.productConfigurationService.configValue.apiKeys['TRAVELLER'];
      newReq = req.clone({
        setHeaders: {
          'x-api-key': xApiKey,
          'fleet-product': this.fleetProduct,
          'fleet-channel': 'WEB',
        },
      });
    } else {
      newReq = req.clone({
        setHeaders: {
          'fleet-product': this.fleetProduct,
          'fleet-channel': 'WEB',
        },
      });
    }

    // Response
    return next.handle(newReq).pipe(
      catchError((error) => {
        // Catch "401 Unauthorized" resnetowrponses
        if (error instanceof HttpErrorResponse) {
          if (error.status === 0) {
            this.onScreenNotitifcationService.setNotification({
              ...failureNotification,
              title: 'Cannot contact server',
              subTitle: 'Please try again',
            });
          } else if (error.status === 401) {
            // Sign out
            this.onScreenNotitifcationService.setNotification({
              title: 'Session has expired',
              subTitle: 'Please log in again',
              autoDismiss: 3000,
              icon: { color: 'warn', name: 'warning' },
            });
            this._authService.logout();

            // Reload the app
            //location.reload();
          } else if (error.status === 503) {
            //redirect to 503 page;
            //this.router.navigate(['/maintenance']);
          }
        }

        return throwError(error);
      })
    );
  }
}
